export const state = {
  moyenQualification: undefined,
  moyenQualifications: [],
  communes: [],
  sousMoyenQualification: undefined,
  sousMoyenQualifications: []
}